export default __webpack_public_path__ + "static/media/virtual-bg2.4e06ba52.png";